// import ReactGA from "react-ga";
import {
  GA_USER_TYPE_USER,
  GA_INFO_NOT_IDENTIFIED,
} from "../constants/defaults";

export const setAnalyticsNumUsersAdded = ({
  number = "0",
  company_uid = GA_INFO_NOT_IDENTIFIED,
  user_type = GA_USER_TYPE_USER,
}) => {
  setAnalyticsEvent({
    category: `[${company_uid}] Adicionando Usuários`,
    action: `[${user_type}] Adicionado: ` + number,
    label: `[${user_type}] Adicionado: ` + number,
  });
};

export const setAnalyticsPlayGame = ({ name = GA_INFO_NOT_IDENTIFIED }) => {
  setAnalyticsEvent({
    category: "Treinamento - Jogo",
    action: "Abriu jogo: " + name,
    label: "Abriu jogo: " + name,
  });
};

const setAnalyticsEvent = ({
  category = `"CATEGORY" not found`,
  action = `"ACTION" Not found`,
  label = `"LABEL" Not found`,
}) => {
  // ReactGA.event({
  //   category: category,
  //   action: action,
  //   label: label,
  //   value: 1,
  // });
};
